import {
  RowDataReducerAction,
  RowDataReducerState,
} from "../../../../../types";
import { isNewRecord } from "../../../helpers";

export const updateDefaultFCCompany = (
  rowDataReducerState: RowDataReducerState,
  dispatch: React.Dispatch<RowDataReducerAction>,
  arCompany: string,
): void => {
  const { rowData } = rowDataReducerState;
  if (isNewRecord(rowData) && arCompany !== null && arCompany !== "") {
    const fieldsToUpdate = [
      "finance_charge_jrnl_company",
      "finance_charge_acct_company",
    ];
    fieldsToUpdate.forEach((field) => {
      if (rowData[field] === null || rowData[field] === "") {
        dispatch({
          type: "UPDATE_FIELD",
          payload: {
            propertyKey: field,
            newFieldValue: arCompany,
          },
        });
      }
    });
  }
};

export const updateDefaultFCStore = (
  rowDataReducerState: RowDataReducerState,
  dispatch: React.Dispatch<RowDataReducerAction>,
  arStore: string,
): void => {
  const { rowData } = rowDataReducerState;
  if (isNewRecord(rowData) && arStore !== null && arStore !== "") {
    const fieldsToUpdate = [
      "finance_charge_jrnl_store",
      "finance_charge_acct_store",
    ];
    fieldsToUpdate.forEach((field) => {
      if (rowData[field] === null || rowData[field] === "") {
        dispatch({
          type: "UPDATE_FIELD",
          payload: {
            propertyKey: field,
            newFieldValue: arStore,
          },
        });
      }
    });
  }
};

export const updateDefaultFCGroup = (
  rowDataReducerState: RowDataReducerState,
  dispatch: React.Dispatch<RowDataReducerAction>,
  arGroup: string,
): void => {
  const { rowData } = rowDataReducerState;
  if (isNewRecord(rowData) && arGroup !== null && arGroup !== "") {
    const fieldsToUpdate = [
      "finance_charge_jrnl_company_group_id",
      "finance_charge_acct_company_group_id",
    ];
    fieldsToUpdate.forEach((field) => {
      if (rowData[field] === null || rowData[field] === "") {
        dispatch({
          type: "UPDATE_FIELD",
          payload: {
            propertyKey: field,
            newFieldValue: arGroup,
          },
        });
      }
    });
  }
};